import React, { useEffect, useState } from "react";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";

import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "../../../../../assets/img/logo/logo_aig_login-2.png";

import CrearCompromisoLayout from "../../../components/CrearCompromisoLayout";

import { getSchema } from "./validation";

import {
    listarActividadesEconomicas,
    listarGirosNegocio,
    listarAseguradoras,
    listarBrokers,
    setDatosNuevoCompromiso,
    guardarCompromiso
} from "../../../redux/aCompromisos";

import {
    selectNuevoCompromiso,
    selectGuardarCompromisoLoading,
    selectBrokers
} from "../../../redux/selectors";

const DatosNegocio = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const nuevoCompromiso = useSelector(selectNuevoCompromiso);
    const guardarCompromisoLoading = useSelector(selectGuardarCompromisoLoading);

    const [giroNegocio, setGiroNegocio] = useState(nuevoCompromiso.giroNegocio || null);
    const [actividadEconomica, setActividadEconomica] = useState(nuevoCompromiso.actividadEconomica || null);
    const [cuentaSeguro, setCuentaSeguro] = useState(nuevoCompromiso.cuentaSeguro || false);
    const [brokerActual, setBrokerActual] = useState(nuevoCompromiso.brokerActual || null);
    const [aseguradoraActual, setAseguradoraActual] = useState(nuevoCompromiso.aseguradoraActual || null);
    const [fechaVencimiento, setFechaVencimiento] = useState(nuevoCompromiso.fechaVencimiento || "");

    const [giros, setGiros] = useState([]);
    const [actividades, setActividades] = useState([]);
    const [aseguradoras, setAseguradoras] = useState([]);

    const [girosFiltrados, setGirosFiltrados] = useState([]);
    const [actividadesFiltradas, setActividadesFiltradas] = useState([]);
    const [aseguradorasFiltradas, setAseguradorasFiltradas] = useState([]);
    const [brokersFiltrados, setBrokersFiltrados] = useState([]);

    const brokers = useSelector(selectBrokers);

    const [errores, setErrores] = useState({});

    useEffect(() => {
        const cargarCatalogos = async () => {
            const [
                respuestaGiros,
                respuestaActividades,
                respuestaAseguradoras,
                respuestaBrokers
            ] = await Promise.all([
                dispatch(listarGirosNegocio()),
                dispatch(listarActividadesEconomicas()),
                dispatch(listarAseguradoras()),
                dispatch(listarBrokers(null))
            ]);

            if (
                respuestaGiros &&
                respuestaGiros.success
            ) {
                setGiros(
                    respuestaGiros.data || []
                );
            }


            if (
                respuestaActividades &&
                respuestaActividades.success
            ) {
                setActividades(
                    respuestaActividades.data || []
                );
            }


            if (
                respuestaAseguradoras &&
                respuestaAseguradoras.success
            ) {
                setAseguradoras(
                    respuestaAseguradoras.data || []
                );
            }
        };


        cargarCatalogos();

    }, [dispatch]);

    const buscarGiros = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";
        const resultados =
            giros.filter((item) => {

                const nombre =
                    item.gnNombre
                        ? item.gnNombre.toLowerCase()
                        : "";

                return nombre.includes(termino);
            });

        setGirosFiltrados(resultados);
    };


    const buscarActividades = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";

        const resultados =
            actividades.filter((item) => {

                const nombre =
                    item.aeNombre
                        ? item.aeNombre.toLowerCase()
                        : "";

                return nombre.includes(termino);
            });

        setActividadesFiltradas(resultados);
    };


    const buscarAseguradoras = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";

        const resultados =
            aseguradoras.filter((item) => {

                const nombre =
                    item.asDescripcion
                        ? item.asDescripcion.toLowerCase()
                        : "";

                return nombre.includes(termino);
            });

        setAseguradorasFiltradas(resultados);
    };


    const buscarBrokers = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";

        const resultados =
            brokers.filter((item) => {

                const texto =
                    item.nombreCompleto
                        ? item.nombreCompleto.toLowerCase()
                        : "";

                return texto.includes(termino);
            });

        setBrokersFiltrados(resultados);
    };

    const guardarDatosRedux = () => {

        dispatch(
            setDatosNuevoCompromiso({

                giroNegocio,

                actividadEconomica,

                cuentaSeguro,

                brokerActual:
                    cuentaSeguro
                        ? brokerActual
                        : null,

                aseguradoraActual:
                    cuentaSeguro
                        ? aseguradoraActual
                        : null,

                fechaVencimiento:
                    cuentaSeguro
                        ? fechaVencimiento
                        : ""
            })
        );
    };


    const handleAnterior = () => {
        guardarDatosRedux();
        history.push("/compromisos/crear/lineas-negocio");
    };

    const handleSiguiente = async () => {
        const datosFormulario = {
            giroNegocio,
            actividadEconomica,
            cuentaSeguro,
            brokerActual,
            aseguradoraActual,
            fechaVencimiento
        };

        try {

            await getSchema().validate(
                datosFormulario,
                {
                    abortEarly: false
                }
            );

            setErrores({});
            guardarDatosRedux();


            const datosGuardar = {
                cmDatosNegocio: {

                    giroNegocio:
                        giroNegocio.gnCodigoCore,

                    actividadEconomica:
                        actividadEconomica.aeCodigoCore,

                    cuentaSeguro,

                    brokerActual:
                        cuentaSeguro && brokerActual
                            ? brokerActual
                            : null,

                    aseguradoraActual:
                        cuentaSeguro && aseguradoraActual
                            ? aseguradoraActual.asCodigo
                            : null,

                    fechaVencimiento:
                        cuentaSeguro
                            ? fechaVencimiento
                            : null
                },

                pasoActual: 4
            };

            const respuesta = await dispatch(
                guardarCompromiso(
                    datosGuardar
                )
            );


            if (!respuesta.success) {
                return;
            }


            dispatch(
                setDatosNuevoCompromiso({
                    ...datosFormulario,
                    idCompromiso:
                        respuesta.idCompromiso,
                    pasoActual: 4
                })
            );

            history.push("/compromisos/crear/informacion-compromiso");
        } catch (error) {


            const erroresFormulario = {};


            if (
                error.inner &&
                error.inner.length > 0
            ) {

                error.inner.forEach((item) => {

                    if (
                        !erroresFormulario[
                        item.path
                        ]
                    ) {

                        erroresFormulario[
                            item.path
                        ] =
                            item.message;
                    }
                });


                setErrores(
                    erroresFormulario
                );

            } else {

                console.error(
                    "ERROR NO CONTROLADO:",
                    error.message
                );
            }
        }
    };
    return (
        <LoadingScreen
            loading={guardarCompromisoLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Guardando informacion..."
        >
            <CrearCompromisoLayout
                activeStep={3}
                tituloPaso="Datos del negocio"
            >

                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>


                        <FormGroup>

                            <Label>
                                Giro de negocio
                            </Label>

                            <AutoComplete
                                value={giroNegocio}
                                suggestions={girosFiltrados}
                                completeMethod={buscarGiros}
                                onChange={(event) =>
                                    setGiroNegocio(
                                        event.value || null
                                    )
                                }
                                field="gnNombre"
                                placeholder="Seleccione un giro de negocio"
                                dropdown
                                className={"w-100 " + (errores.giroNegocio ? "p-invalid" : "")}
                            />

                            {errores.giroNegocio && (
                                <small className="text-danger">
                                    {errores.giroNegocio}
                                </small>
                            )}

                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <FormGroup>
                            <Label>
                                Actividad económica principal
                            </Label>
                            <AutoComplete
                                value={actividadEconomica}
                                suggestions={
                                    actividadesFiltradas
                                }
                                completeMethod={
                                    buscarActividades
                                }
                                onChange={(event) =>
                                    setActividadEconomica(
                                        event.value || null
                                    )
                                }
                                field="aeNombre"
                                placeholder="Seleccione una actividad económica"
                                dropdown
                                className={"w-100 " + (errores.actividadEconomica ? "p-invalid" : "")}
                            />

                            {errores.actividadEconomica && (
                                <small className="text-danger">
                                    {errores.actividadEconomica}
                                </small>
                            )}

                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <div
                                className="d-flex align-items-center"
                            >
                                <Checkbox
                                    inputId="cuentaSeguro"
                                    checked={
                                        cuentaSeguro
                                    }
                                    onChange={(event) => {
                                        setCuentaSeguro(event.checked);

                                        if (!event.checked) {
                                            setBrokerActual(null);
                                            setAseguradoraActual(null);
                                            setFechaVencimiento("");
                                        }
                                    }}
                                />

                                <Label
                                    htmlFor="cuentaSeguro"
                                    className="ml-2 mb-0"
                                >
                                    ¿Cuenta con seguro?
                                </Label>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>

                {cuentaSeguro && (
                    <>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <FormGroup>

                                    <Label>
                                        Broker actual
                                    </Label>
                                    <AutoComplete
                                        value={brokerActual}
                                        suggestions={brokersFiltrados}
                                        completeMethod={buscarBrokers}
                                        onChange={(event) =>
                                            setBrokerActual(
                                                event.value || null
                                            )
                                        }
                                        field="nombreCompleto"
                                        placeholder="Seleccione un broker"
                                        dropdown
                                        className={"w-100 " + (errores.brokerActual ? "p-invalid" : "")}
                                    />

                                    {errores.brokerActual && (
                                        <small className="text-danger">
                                            {errores.brokerActual}
                                        </small>
                                    )}

                                </FormGroup>

                            </Col>

                            <Col lg={6} md={6} sm={6} xs={12}>
                                <FormGroup>

                                    <Label>
                                        Aseguradora actual
                                    </Label>

                                    <AutoComplete
                                        value={aseguradoraActual}
                                        suggestions={aseguradorasFiltradas}
                                        completeMethod={buscarAseguradoras}
                                        onChange={(event) =>
                                            setAseguradoraActual(
                                                event.value || null
                                            )
                                        }
                                        field="asDescripcion"
                                        placeholder="Seleccione una aseguradora"
                                        dropdown
                                        className={"w-100 " + (errores.aseguradoraActual ? "p-invalid" : "")}
                                    />

                                    {errores.aseguradoraActual && (
                                        <small className="text-danger">
                                            {errores.aseguradoraActual}
                                        </small>
                                    )}

                                </FormGroup>

                            </Col>


                        </Row>
                        <Row>

                            <Col lg={6} md={6} sm={12} xs={12}>

                                <FormGroup>

                                    <Label>
                                        Fecha vencimiento
                                    </Label>

                                    <InputText
                                        type="date"
                                        value={fechaVencimiento}
                                        onChange={(event) =>
                                            setFechaVencimiento(
                                                event.target.value
                                            )
                                        }
                                        className={"w-100 " + (errores.fechaVencimiento ? "p-invalid" : "")}
                                    />

                                    {errores.fechaVencimiento && (
                                        <small className="text-danger">
                                            {errores.fechaVencimiento}
                                        </small>
                                    )}

                                </FormGroup>

                            </Col>

                        </Row>


                    </>
                )}

                <div className="compromiso-actions">

                    <Button
                        className="compromiso-button compromiso-button-regresar"
                        onClick={handleAnterior}
                    >
                        <span aria-hidden="true" className="compromiso-button-icon">‹</span>
                        Regresar
                    </Button>

                    <Button
                        className="compromiso-button compromiso-button-consultar"
                        //disabled={!formularioValido()}
                        onClick={handleSiguiente}
                    >
                        Siguiente
                    </Button>


                </div>
            </CrearCompromisoLayout>
        </LoadingScreen>
    );
};

export default DatosNegocio;